module.exports = __webpack_public_path__ + "img/logo1.86c9822c.png";